import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles/score-card.css';

export default function ScoreCard({ label, score, explanation, suggestions, expandAll, isHighlighted, metricKey }) {
  const numeric = parseFloat(score);
  const rounded = Number.isInteger(numeric) ? numeric : numeric.toFixed(1);
  const gradeCls = `grade-${Math.round(numeric)}`;
  const [open, setOpen] = useState(expandAll);
  
  useEffect(() => { 
    setOpen(expandAll); 
  }, [expandAll]);

  // Auto-expand if this card is highlighted
  useEffect(() => {
    if (isHighlighted) {
      setOpen(true);
    }
  }, [isHighlighted]);

  return (
    <div 
      className={`score-card ${gradeCls} ${isHighlighted ? 'score-card-highlighted' : ''}`} 
      style={{background:'#fff', color:'#111'}}
      data-metric-key={metricKey} // NEW: Add data attribute for targeting
    >
      <button 
        className="w-100 text-start score-header btn btn-link p-0 mb-2" 
        onClick={() => setOpen(o => !o)}
      >
        <span className="fw-semibold">
          {label}
          {isHighlighted && <span className="ms-2 badge bg-warning text-dark">🎯</span>}
        </span>
        <span className={`score-badge ms-auto ${gradeCls}`}>{rounded}</span>
      </button>

      {open && (
        <>
          {explanation && <p className="score-explanation mb-2">{explanation}</p>}
          {Array.isArray(suggestions) && suggestions.length > 0 && (
            <div className="score-suggestions">
              <p className="suggestions-title">Suggestions</p>
              <ul className="suggestions-list">
                {suggestions.map((s, i) => <li key={i}>{s}</li>)}
              </ul>
            </div>
          )}
        </>
      )}
    </div>
  );
}

ScoreCard.propTypes = {
  label: PropTypes.string.isRequired,
  score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  explanation: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string),
  expandAll: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  metricKey: PropTypes.string // NEW: metric key for targeting
};